/**
 * Fixes text where UTF-8 bytes were misinterpreted as Latin-1 (e.g. "â€"" instead of "—").
 */
export function fixUtf8Mojibake(text: string | null | undefined): string {
  if (!text) return text ?? '';
  if (!text.includes('\u00E2')) return text;

  try {
    const bytes = Uint8Array.from(text, (c) => c.charCodeAt(0) & 0xff);
    const fixed = new TextDecoder('utf-8', { fatal: true }).decode(bytes);
    if (fixed !== text && !fixed.includes('\uFFFD')) return fixed;
  } catch {
    // Not mojibake — return original.
  }

  return text;
}
